<template>
  <div class="home">
    <div class="language_box" @click="showLanguageBox">
      <div class="language">
        <img src="@/assets/image/Language.png" style="width: 20px;margin-right: 8px;" alt="" />
        <img src="@/assets/image/Polygon.png" style="width: 8px;" alt="" />
      </div>
    </div>
    <div class="flex-row">
      <img src="@/assets/logo.png" style="width: 25px;margin-right: 6px;" alt="">
      <h3 class="projectName">{{ $t(`Unichat 互信`) }}</h3>
    </div>
    <div style="margin: 20px 0 40px;">
      <h3 class="title">{{ $t(`注册账号！`) }}</h3>
      <span style="color: #636469;">{{ isPhone ? $t(`输入您的手机号码注册`) : $t(`输入您的邮箱注册`) }}</span>
    </div>
<!--    <TabComponent
      :tabs="tabs"
      v-model="activeTab"
    />-->
    <div style="margin-top: 20px;">
      <div>
        <div class="label">{{ isPhone ? $t(`手机账号`) : $t(`邮箱账号`) }}</div>
        <div class="flex-row" v-if="isPhone">
          <div class="area" @click="$refs.country.showPopup = true">
            <span :style="selectedCountry ? {} : {color: '#c2c2c2'}">{{ selectedCountry ? `+${selectedCountry.code}` : $t(`区号`) }}</span>
            <img src="@/assets/icon/arrow.svg" class="arrow" alt="" />
          </div>
          <InputComponent
            v-model="mobile"
            :placeholder="$t(`请输入您的手机号`)"
          />
        </div>
        <InputComponent
          v-else
          v-model="email"
          :placeholder="$t(`请输入您的邮箱账号`)"
        />
      </div>
    </div>
    <div class="flex-row" style="margin-top: 24px;">
      <InputComponent
        v-model="verifyCode"
        :placeholder="$t(`验证码`)"
      />
      <button
        class="btn"
        style="width: 108px;margin-left: 6px;"
        :disabled="loading"
        @click="getCode">{{ countdown > 0 ? `${countdown}s` : $t(`获取验证码`) }}</button>
    </div>
    <div style="margin-top: 10px;">
      <CheckboxComponent v-model="isChecked">
        <div class="flex-row" style="color: #C2C2C2;white-space: nowrap;">
          <span>{{ $t(`我已阅读`) }}</span>
<!--          <span class="link" @click.stop.prevent="checkAgreement">{{ $t(`隐私协议`) }}</span>
          <span>{{ $t(`和`) }}</span>-->
          <span class="link" @click.stop.prevent="checkAgreement">《{{ $t(`用户协议`) }}》</span>
        </div>
      </CheckboxComponent>
    </div>
    <button
        class="btn"
        style="margin-top: 60px;"
        :disabled="loading2 || !verifyCode"
        @click="onNext">{{ $t(`下一步`) }}</button>
    <RouterLink to="/download">
      <div style="display: flex;align-items: center;justify-content: center;margin: 54px auto 20px;color: #000;">
        <img src="@/assets/image/download-icon.png" style="width: 21.3vw;height: 20vw;" alt="">
        <div style="text-align: center;margin-left: 14px;">
          <div style="font-size: 20px;font-weight: 600;margin-bottom: 4px;">{{ $t(`前往下载中心`) }}</div>
          <div style="font-size: 12px;">{{ $t(`支持 IOS / Android / Windows / Mac`) }}</div>
        </div>
      </div>
    </RouterLink>
    <!-- 下一步 -->
    <div :class="['next-box', showNextPanel ? 'show' : '']">
      <img src="@/assets/icon/back.svg" alt="" @click="showNextPanel = false">
      <div style="margin: 24px 0;">
        <h3 class="title">{{ $t(`设置基本信息`) }}</h3>
      </div>
      <div style="display: grid;grid-auto-flow: row;gap: 16px;margin-top: 20px;">
        <div @click="$refs.country.showPopup = true">
          <div class="label" style="color: #9C9C9C;">{{ $t(`国家和地区`) }}</div>
          <div style="display: flex;align-items: center;position: relative;height: 50px;background: #EAEAEA;border-radius: 8px;padding: 0 16px;">
            <div v-if="selectedCountry" style="display: flex;align-items: center;">
              <div style="margin-right: 10px;">{{ selectedCountry.name }}</div>
            </div>
            <span v-else style="color: #7E7E7E;">{{$t(`请选择国家`)}}</span>
            <img src="@/assets/image/arrow.png" style="width: 20px;position: absolute;top: 50%;right: 16px;transform: translateY(-50%)" alt="" />
          </div>
        </div>
        <div>
          <div class="label">{{ $t(`设置用户名`) }}</div>
          <InputComponent
              v-model="username"
              ref="username"
              :placeholder="$t(`请输入您的用户名`)"
              :help="$t(`用户名为6-18位，大小写字母或数字`)"
              :rules="['^[a-zA-Z0-9]{6,18}$']"
          />
        </div>
        <div>
          <div class="label">{{ $t(`设置登录密码`) }}</div>
          <InputComponent
              type="password"
              ref="password"
              v-model="pwd"
              :placeholder="$t(`设置登录密码`)"
              :help="$t(`密码必须是8-20位字母和数字组合，不能是纯数字或纯字母`)"
              :rules="['^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$']"
          />
        </div>
        <div>
          <div class="label">{{ $t(`交易密码`) }}</div>
          <InputComponent
              type="password"
              ref="safePassword"
              v-model="payPwd"
              :placeholder="$t(`输入6位数字的交易密码`)"
              :maxlength="6"
              :help="$t(`交易密码必须是6位数字组合`)"
              :rules="['^\\d{6}$']"
          />
        </div>
        <div>
          <div class="label">{{ $t(`邀请码（选填）`) }}</div>
          <InputComponent
              v-model="inviteCode"
              :placeholder="$t(`邀请码`)"
          />
        </div>
        <button class="btn" style="margin-top: 60px;" :disabled="submitLoading" @click="onRegister">{{ $t(`注册`) }}</button>
      </div>
    </div>
    <country-code-popup
      ref="country"
      :country-list="countryList"
      @select="handleCountrySelect"
    />
    <AgreementPopup ref="agreementPopup" />
    <LanguagePopup ref="languagePopup" />
  </div>
</template>

<script>
// import TabComponent from '@/components/tab/TabComponent.vue';
import InputComponent from '@/components/input/InputComponent.vue';
import CheckboxComponent from '@/components/checkbox/CheckboxComponent.vue';
import CountryCodePopup from '@/components/countryCodePopup/CountryCodePopup.vue';
import AgreementPopup from '@/components/agreement/AgreementPopup.vue';
import LanguagePopup from '@/components/languagePopup/LanguagePopup.vue';
import axios from "axios";
export default {
  name: 'HomeView',
  components: {
    /*TabComponent,*/
    InputComponent,
    CheckboxComponent,
    CountryCodePopup,
    AgreementPopup,
    LanguagePopup
  },
  data() {
    return {
      activeTab: 'email',
      tabs: [
        { label: '手机注册', value: 'phone' },
        { label: '邮箱注册', value: 'email' }
      ],
      mobile: '',
      email: '',
      verifyCode: '',
      loading: false, // 获取验证码按钮是否禁用
      countdown: 0,     // 倒计时秒数
      countdownInterval: null,  // 倒计时定时器
      isChecked: false,
      hasSendCode: false, // 是否已发送验证码
      loading2: false, // 点击下一步按钮是否禁用
      submitLoading: false,
      selectedCountry: undefined,
      countryList: [
        { id: 1, code: "1", name: "United States" },
        { id: 2, code: "44", name: "United Kingdom" },
        { id: 3, code: "91", name: "India" },
        { id: 4, code: "86", name: "China" },
        // ...其他国家数据
      ],
      showNextPanel: false,
      pwd: '',
      payPwd: '',
      username: '',
      inviteCode: this.$route.query.inviteCode || '',
      verifyToken: ''
    }
  },
  computed: {
    isPhone() {
      return this.activeTab === 'phone';
    }
  },
  methods: {
    handleCountrySelect(country) {
      this.selectedCountry = country;
    },
    showLanguageBox() {
      this.$refs.languagePopup.showPopup = true;
    },
    checkAgreement() {
      this.$refs.agreementPopup.showPopup = true;
    },
    onNext() {
      if (!this.hasSendCode) {
        this.$toast('请先获取验证码');
        return;
      }
      if (!this.verifyCode) {
        this.$toast('请输入验证码');
        return;
      }
      if (!this.isChecked) {
        this.$toast('请先阅读并同意协议');
        return;
      }
      this.loading2 = true;
      axios.post('/api/st-auth/newuser/verify', {
        areaCode: this.selectedCountry && this.selectedCountry.code,
        email: this.email,
        emailCode: this.verifyCode,
        imgCode: "",
        mobile: this.mobile,
        mobileCode: this.verifyCode,
        type: this.isPhone ? 'sms' : 'email'
      }).then((res) => {
        if (res.data && res.data.code === 200) {
          this.verifyToken = res.data.data;
          this.showNextPanel = true;
        } else if(res.data) {
          this.$toast(res.data.message || '服务繁忙');
        }
        this.loading2 = false;
      }).catch(() => {
        this.loading2 = false;
      })

    },
    getCode() {
      if (this.isPhone && !this.selectedCountry.code) {
        this.$toast(this.$t(`请选择区号`));
        return;
      }
      if (this.isPhone && !this.mobile) {
        this.$toast(this.$t(`请输入手机号`));
        return;
      }
      if (!this.isPhone && !this.email) {
        this.$toast(this.$t(`请输入邮箱`));
        return;
      }
      this.loading = true;
      axios.post('/api/st-auth/newuser/sendRegisterCode', {
        areaCode: this.selectedCountry && this.selectedCountry.code,
        email: this.email,
        mobile: this.mobile,
        type: this.isPhone ? 'sms' : 'email'
      }).then((res) => {
        if (res.data && res.data.code === 200) {
          this.$toast(this.$t(`验证码已发送`));
          this.hasSendCode = true;
          this.countdown = 60;
          this.countdownInterval = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.countdownInterval);
              this.loading = false;
            }
          }, 1000);
        } else if(res.data) {
          this.loading = false;
          this.$toast(res.data.message || this.$t(`服务繁忙`));
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    onRegister() {
      /*if (!this.pwd || !this.payPwd || !this.username || !this.pwd) {
        this.$toast(this.$t(`请填写完整信息`));
        return;
      }
      if (/\s/.test(this.username)) {
        this.$toast(this.$t(`用户名不能包含空格符`));
        return;
      }
      if (this.username.trim().length < 2) {
        this.$toast(this.$t(`用户名长度不能小于2位`));
        return;
      }
      /!*交易密码必须是6位纯数字*!/
      if (!/^\d{6}$/.test(this.payPwd)) {
        this.$toast(this.$t(`交易密码必须是6位纯数字`));
        return;
      }*/
      const validateInfo = this.$refs.username.validate() || this.$refs.password.validate() || this.$refs.safePassword.validate();
      if (validateInfo) {
        this.$toast({
          message: validateInfo.message,
          wordBreak: 'break-word'
        });
        return;
      }
      this.submitLoading = true;
      axios.post('/api/st-auth/newuser/register', {
        pwd: this.pwd,
        payPwd: this.payPwd,
        username: this.username,
        inviteCode: this.inviteCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.data && res.data.code === 200) {
          this.$toast(this.$t(`注册成功`));
          setTimeout(() => {
            this.$router.push({
              path: '/download',
            })
          }, 1000);
        } else if(res.data) {
          this.$toast(res.data.message || this.$t(`服务繁忙`));
        }
      }).finally(() => {
        this.submitLoading = false;
      })
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  padding: 24px 16px 54px;
  box-sizing: border-box;
  position: relative;
}
.projectName{
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}
.title{
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 16px;
}
.label{
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}
.area{
  width: 104px;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid #D0D1D2;
  border-radius: 10px;
  padding-left: 16px;
  box-sizing: border-box;
  margin-right: 6px;
  .arrow{
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.btn{
  width: 100%;
  height: 50px;
  border-radius: 10px;
  background-color: #29D769;
  font-size: 14px;
  color: #fff;
  box-shadow: none;
  outline: none;
  border: none;
  &:disabled{
    opacity: 0.5;
  }
}
.link{
  color: #29D769;
  margin: 2px;
}

.next-box{
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  padding: 24px 16px 54px;
  box-sizing: border-box;
  &.show{
    display: inline-block;
  }
}
.language_box{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
  .language{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
